import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../../shared/models/user.model';
import { Token } from '../../shared/models/token.model';

import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Title } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})

export class AuthenticationService {
	public loginUser: Observable<User>;
	public loginToken: Observable<Token>;
	private currentUserSubject: BehaviorSubject<User>;
	private currentTokenSubject: BehaviorSubject<Token>;
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;
	loginCurrentUser: any;
	userAccessToken: any;
	private headers: any;
	private title: Title;
	constructor(
		public router: Router,
		private http: HttpClient,
		public toastrService: ToastrService,
		public translate: TranslateService,
		public ngxRolesService: NgxRolesService,
		public ngxPermissionsService: NgxPermissionsService,
		private cookieService: CookieService
	) {
		this.headers = new HttpHeaders({ 'Cache-Control': 'no-cache', 'Pregma': 'no-cache' });
		//if(localStorage.getItem('loginUser')) {
		const cookieValue = this.cookieService.get('jwt_token');
		if (cookieValue != "") {
			localStorage.setItem('token', cookieValue);
			this.router.navigate(['dashboard']);
		}
		this.loginCurrentUser = JSON.parse(localStorage.getItem('loginUser'));
		this.userAccessToken = localStorage.getItem('token');
		//}
		this.currentUserSubject = new BehaviorSubject<User>(this.loginCurrentUser);
		this.currentTokenSubject = new BehaviorSubject<Token>(this.userAccessToken);
		this.loginUser = this.currentUserSubject.asObservable();
		this.loginToken = this.currentTokenSubject.asObservable();
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	public get currentTokenValue(): Token {
		return this.currentTokenSubject.value;
	}

	setLoginUser(user) {

		localStorage.setItem('loginUser', JSON.stringify(user));
		this.setUserPermissions(user);
		this.currentUserSubject.next(user);

	}

	setLoggedUser(user) {
		localStorage.setItem('loggedUser', JSON.stringify(user));
		this.currentUserSubject.next(user);

	}

	// setUserPermissions(user) {
	// 	this.ngxRolesService.flushRoles();
	// 	this.ngxPermissionsService.flushPermissions();

	// 	localStorage.setItem("permissions", JSON.stringify(user));

	// 	for (let iRow in user.permissions) {
	// 		this.ngxPermissionsService.addPermission(user.permissions[iRow]);
	// 	}
	// 	this.ngxRolesService.addRoles(user.permissions);
	// }

	// setUserPermissions(user) {

	// 	this.ngxRolesService.flushRoles();
	// 	this.ngxPermissionsService.flushPermissions();

	// 	localStorage.setItem("permissions", JSON.stringify(user.permissions.admin));

	// 	for (let iRow in user.permissions.admin) {
	// 		this.ngxPermissionsService.addPermission(user.permissions.admin[iRow]);
	// 	}
	// 	this.ngxRolesService.addRoles(user.permissions.admin);
	// }

	setUserPermissions(user) {

		this.ngxRolesService.flushRoles();
		this.ngxPermissionsService.flushPermissions();

		let permissions: any = [];

		if (
			user &&
			user.permissions &&
			user.permissions.admin &&
			Array.isArray(user.permissions.admin)
		) {
			permissions = user.permissions.admin;
		}

		// Store safely
		localStorage.setItem('permissions', JSON.stringify(permissions));

		// Add only if exists
		if (permissions.length > 0) {
			this.ngxPermissionsService.addPermission(permissions);
			this.ngxRolesService.addRoles(permissions);
		}
	}


	getToken() {
		return localStorage.getItem('token')
	}

	isLoggedIn() {
		return this.getToken() !== null;
	}

	// register(user: User) {
	// 	return this.http.post(`${this.apiUrl}/api/register`, user);
	// }

	register(user: any) {
		return this.http.post(`${this.apiUrl1}/api/auth/register`, user);
	}


	registerOtp(key: string, otp: string) {
		return this.http.post(`${this.apiUrl1}/api/auth/verify-otp`, { key, otp });
	}

	// login(email: string, password: string) {
	// 	return this.http.post<any>(`${this.apiUrl}/api/login`, { email, password })
	// 		.pipe(map(user => {
	// 			if (user) {
	// 				localStorage.setItem('access_token', JSON.stringify(user));
	// 				this.currentTokenSubject.next(user);
	// 			}
	// 			return user;
	// 		}));
	// }

	login(email: string, password: string) {
		return this.http.post<any>(`${this.apiUrl1}/api/auth/login`, { email, password }, this.headers);
		// return this.http.post<any>(`${this.apiUrl1}/api/auth/login`,{email,password})
		// .pipe(map(user => {
		// 		if (user) {
		// 			localStorage.setItem('token', JSON.stringify(user));
		// 			localStorage.setItem('profile_status_percentage', JSON.stringify(user.data.profile_status_percentage));
		// 			this.currentTokenSubject.next(user);
		// 			console.log(user)
		// 		}
		// 	return user;
		// }));

	}

	forgotPassword(email) {
		return this.http.post(`${this.apiUrl1}/api/auth/forgot-password`, email);
	}

	getVerifyUser(data) {
		return this.http.post(`${this.apiUrl}/api/verify/user`, data);
	}

	getVerifyUserToken(data) {
		return this.http.post(`${this.apiUrl}/api/verify/token`, data);
	}

	resetPassword(data) {
		return this.http.post(`${this.apiUrl1}/api/auth/reset-password`, data);
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();
		this.cookieService.deleteAll();
		// this.router.navigate(['/login']);
		this.router.navigate(['/login']).then(() => {
			this.title.setTitle('InSiderSys'); // 👈 Force title after logout
		});
		//localStorage.removeItem('token');

		// Optionally clear current user
		//this.currentUserSubject.next(null);

		// if (redirect) {
		// 	this.router.navigate(['/login']);
		// }
		// this.http.get(`${this.apiUrl}/api/logout`)
		// 	.subscribe(
		// 		data => {
		// 			localStorage.removeItem('loginUser');
		// 			localStorage.removeItem('access_token');
		// 			if (isheader) {
		// 				this.toastrService.success(this.translate.instant('common.error_messages.message6'));
		// 			}

		// 			if (localStorage.getItem("permissions") != 'undefined' && localStorage.getItem("permissions") != null) {
		// 				localStorage.removeItem("permissions");
		// 			}

		// 			this.router.navigate(['/login']);
		// 		});
		// this.cookieService.delete('jwt_token');
		// localStorage.removeItem('loginUser');
		// localStorage.removeItem('token');
		// localStorage.removeItem("permissions");
		// localStorage.removeItem("profile_status_percentage");
		// localStorage.removeItem("business_account_id");
	}

	stepperRegister(data: any) {
		return this.http.post(`${this.apiUrl1}/api/auth/register/business-account`, data)
	}

	verifyEmail(email: any) {
		return this.http.post(`${this.apiUrl1}/api/auth/email-verification`, { email: email })
	}

	verifyComplaince(complainceType: any, data) {
		return this.http.post(`${this.apiUrl1}/api/compliance/verify/${complainceType}`, data)
	}

	isTokenExpired(): boolean {

		const token = this.getToken();
		if (!token) {
			return true; // Token doesn't exist or is not valid
		}

		const tokenParts = token.split('.');
		if (tokenParts.length !== 3) {
			return true; // Invalid token format
		}

		const payload = JSON.parse(atob(tokenParts[1]));
		if (!payload || !payload.exp) {
			return true; // Missing expiration or invalid payload
		}

		const now = Math.floor(Date.now() / 1000); // Current time in seconds
		return payload.exp < now; // Check if expiration time is in the past

	}
}
